import { nanoid } from "nanoid";
import { DateTime } from "luxon";

export const createDefaultAvailability = () => {
  return [
    {
      blocks: [],
      day: "sunday",
      unavailable: true,
      dayIndex: 0,
    },
    {
      blocks: [
        {
          startTime: { id: nanoid(), name: "09:00" },
          endTime: { id: nanoid(), name: "17:00" },
        },
      ],
      day: "monday",
      unavailable: false,
      dayIndex: 1,
    },
    {
      blocks: [
        {
          startTime: { id: nanoid(), name: "09:00" },
          endTime: { id: nanoid(), name: "17:00" },
        },
      ],
      day: "tuesday",
      unavailable: false,
      dayIndex: 2,
    },
    {
      blocks: [
        {
          startTime: { id: nanoid(), name: "09:00" },
          endTime: { id: nanoid(), name: "17:00" },
        },
      ],
      day: "wednesday",
      unavailable: false,
      dayIndex: 3,
    },
    {
      blocks: [
        {
          startTime: { id: nanoid(), name: "09:00" },
          endTime: { id: nanoid(), name: "17:00" },
        },
      ],
      day: "thursday",
      unavailable: false,
      dayIndex: 4,
    },
    {
      blocks: [
        {
          startTime: { id: nanoid(), name: "09:00" },
          endTime: { id: nanoid(), name: "17:00" },
        },
      ],
      day: "friday",
      unavailable: false,
      dayIndex: 5,
    },
    {
      blocks: [],
      day: "saturday",
      unavailable: true,
      dayIndex: 6,
    },
  ];
};

export const dayIndex = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const format24to12 = (time) => {
  return DateTime.fromISO(`1970-01-01T${time}`).toFormat("hh:mm a");
};

export const format12To24 = (time12hr) => {
  const date = DateTime.fromFormat(
    `1970-01-01 ${time12hr}`,
    "yyyy-MM-dd hh:mm a"
  );
  if (!date.isValid) {
    console.warn("Invalid time format:", time12hr);
    return null; // or return "" if you prefer
  }
  return date.toFormat("HH:mm");
};

export const parseTime = (timeStr) => {
  const [hour, minute] = timeStr.split(":").map(Number);
  return { hour, minute };
};

export const AVAILABILITY_TYPES = {
  REGION: "region",
  DISTANCE: "distance",
  FIXED: "fixed",
};

export const ADDRESS_TYPES = {
  ADDRESS: "address",
  REGION: "region",
};

// mobile = provider travels to client; fixed = client visits provider; hybrid = either (client chooses at booking)
export const DELIVERY_TYPES = {
  MOBILE: "mobile",
  FIXED: "fixed",
  HYBRID: "hybrid",
};
